import twMerge from 'utils/twMerge';

type AccessibleLinkProps = {
    title: string;
    href: string;
};

export const AccessibleLink: FC<AccessibleLinkProps> = ({ title, href, className }) => {
    return (
        <a
            href={href}
            tabIndex={0}
            className={twMerge(
                'absolute left-0 -translate-x-[1500rem] focus-visible:top-0 focus-visible:translate-x-0',
                'z-aboveOverlay w-full bg-blueVeryLight p-2 text-center text-body font-semibold no-underline',
                className,
            )}
        >
            {title}
        </a>
    );
};
